/**
 * LE DOCUMENT D'EXEMPLE des aperçus de cartouche.
 *
 * Partagé par l'aperçu de la page (`ApercuCartouche`) et par le rendu en direct
 * de chaque mention (`MentionsSituation`) : les deux doivent montrer le MÊME
 * document, sinon on compare deux tirages différents en croyant comparer deux
 * réglages.
 *
 * Les valeurs sont volontairement ordinaires — un exemplaire n° 2 affiché en
 * paillasse, pas un cas limite : l'aperçu sert à lire une phrase, pas à tester
 * les bornes.
 */
import type { ValeursMention } from '@/lib/mentionsCartouche';

export const EXEMPLE = {
  code: 'IT-PRE-003',
  titre: 'Prélèvement veineux — mémo de paillasse',
  version: '1.0',
  statut: 'En vigueur',
  numero: '2',
  lieu: 'Paillasse biochimie',
  redacteurs: 'Asma Ezzi',
  verificateur: 'Manel Haddada',
  approbateur: 'Inès Harzallah',
};

export const jjmmaaaa = (d: Date) =>
  `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;

/** Les jetons, valorisés sur le document d'exemple. `par` est la personne qui
 *  édite : à l'écran de paramétrage, c'est celle qui regarde. */
export function valeursExemple(labo: string, par: string): ValeursMention {
  const jour = jjmmaaaa(new Date());
  return {
    date: jour,
    par: par || 'Inès Harzallah',
    code: EXEMPLE.code,
    titre: EXEMPLE.titre,
    version: EXEMPLE.version,
    statut: EXEMPLE.statut,
    labo: labo || 'BIO24 Alliance',
    dateVigueur: jour,
    numero: EXEMPLE.numero,
    lieu: EXEMPLE.lieu,
  };
}
